// StatCard.jsx
export default function StatCard({ title, value, progress, color }) {
  return (
    <div className="bg-white/70 rounded-xl p-4 border border-gray-200">
      <div className="text-gray-600 text-sm mb-1">{title}</div>
      <div className="text-xl font-bold mb-3">{value}</div>
      <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full bg-gradient-to-r ${color}`}
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
}
